module.exports = __webpack_public_path__ + "static/img/Aions_Mar_1.f5586dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_1.png
// module id = 0pCy
// module chunks = 19